import { render } from "./plick.vue?vue&type=template&id=e41fd150&bindings={\"navigate\":\"props\"}"
import script from "./plick.vue?vue&type=script&lang=js"
export * from "./plick.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./plick.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script